import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import Footer from '~root/src/components/Footer.vue?shadow'
window.customElements.define('daihatsu-footer', wrap(Vue, Footer))

import FooterDark from '~root/src/components/FooterDark.vue?shadow'
window.customElements.define('daihatsu-footer-dark', wrap(Vue, FooterDark))

import Navbar from '~root/src/components/Navbar.vue?shadow'
window.customElements.define('daihatsu-navbar', wrap(Vue, Navbar))

import Widget from '~root/src/components/Widget.vue?shadow'
window.customElements.define('daihatsu-widget', wrap(Vue, Widget))